import { createFileRoute } from '@tanstack/react-router'
import { requireRole } from '@/lib/auth-guards'
import { BillingsPage } from '@/features/finance/billings/pages/billings-page'

export const Route = createFileRoute('/_authenticated/billing/')({
  component: BillingsPage,
  beforeLoad: requireRole(['admin']),
})
